import { isExpired } from '../utils/dateUtils';

const CACHE_VERSION = 5;
const CACHE_NAME_ID = 'parookaville';

export async function getData(url:string) {
  const cacheName = `${CACHE_NAME_ID}-${CACHE_VERSION}`;
  let cachedData = await getCachedData(cacheName, url);

  if (cachedData) {
    return cachedData;
  }

  const cacheStorage = await caches.open(cacheName);
  await cacheStorage.add(url);
  cachedData = await getFetchedData(cacheName, url);
  await deleteOldCaches(cacheName);

  return cachedData;
}

// Get data from the cache.
export async function getCachedData(cacheName:string, url:string) {
  const cacheStorage = await caches.open(cacheName);

  const cachedResponse = await cacheStorage.match(url);

  if (!cachedResponse || !cachedResponse.ok) {
    return false;
  }

  // Check if Cache is expired
  const expiresHeader = cachedResponse.headers.get('expires');
  if (expiresHeader) {
    const hasExpired = isExpired(expiresHeader.toString());
    if (hasExpired) {
      return false;
    }
  }

  return await cachedResponse.json();
}

// Get data from the cache.
export async function getFetchedData(cacheName:string, url:string) {
  const cacheStorage = await caches.open(cacheName);

  const cachedResponse = await cacheStorage.match(url);

  if (!cachedResponse || !cachedResponse.ok) {
    return false;
  }

  return await cachedResponse.json();
}

// Delete any old caches to respect user's disk space.
export async function deleteOldCaches(currentCache:string) {
  const keys = await caches.keys();

  for (const key of keys) {
    const isOurCache = key.startsWith(`${CACHE_NAME_ID}-`);
    if (currentCache === key || !isOurCache) {
      continue;
    }
    caches.delete(key);
  }
}

// Delete any old caches to respect user's disk space.
export async function deleteAllCaches(currentCache:string) {
  const keys = await caches.keys();

  for (const key of keys) {
    if (currentCache === key) {
      continue;
    }
    caches.delete(key);
  }
}